import { format } from 'date-fns';
import { de, enGB, es, fr, it, nl, pl, pt } from 'date-fns/locale'; // Import required locales

// TODO: get rid of it and use useDateLocale hook
export default function formatDateToLocale(date, locale) {
  date = new Date(date); // Convert to date object
  const locales = { en: enGB, fr, es, de, it, pl, pt, nl }; // Add more locales as needed
  const userLocale = locales[locale] || enGB; // Default to enUS if locale not found
  return format(date, 'P', { locale: userLocale }); // 'P' is a localized date format string
}
